import { OrderPicklistExtra, PageProps } from '../../components/types'
import HeaderDetail from '../../components/HeaderDetail'
import { PicklistItemQaCheckMvColumn } from '../../constants/Column'
import Modal from '../../components/Modal'

import OrderPicklistReducer, { 
  INITIAL_STATE, 
  PicklistAction
} from '../../states/PicklistReducer'
import {
  qaCheckItemMovement,
  qaUncheckItemMovement,
  getExtraPicklist,
  getMovementsById,
  qaCheckPicklistExtra
} from '../../states/PicklistAction'

import DataGrid, { RowsChangeData } from 'react-data-grid'

import { 
  useReducer, 
  useEffect,
  useState
} from 'react'
import { AiOutlineCheckCircle } from 'react-icons/ai'
import { HiMagnifyingGlass } from 'react-icons/hi2'
import { groupBy as rowGrouper } from 'lodash';
import { formatDateFromUnix } from '../../utilities/Format'
import { 
  DgtPdOrderPicklist, 
  DgtPdOrderPicklistMovement 
} from '../../models'

import { Link } from 'react-router-dom'

const PicklistQaCheckDetailExtra = ({ title, id, username, extraId, readOnly } : PageProps) => {

  const [ state, dispatch ] = useReducer(
    OrderPicklistReducer, INITIAL_STATE);
  
  const [ originalExtra, setOriginalExtra ] = useState<OrderPicklistExtra>()
  
  const [expandedGroupIds, setExpandedGroupIds] = useState<ReadonlySet<unknown>>(
    () => new Set<unknown>([''])
  );

  useEffect(() => {
    const fetchExtra = async (id: string) => {
      const extraPicklist = await getExtraPicklist(id)
      if (extraPicklist) {
        const orderInfo : DgtPdOrderPicklist = JSON.parse(extraPicklist?.orderInfo)
        
        const extraItems = extraPicklist.extraReturnItems || []
        const toPicklistItems: any = extraItems.map(itm => ({
          pk: itm?.orderId!,
          sk: `ITEM#${itm?.materialCode}`,
          id: itm?.id,
          materialType: '',
          materialCode: itm?.materialCode,
          materialDescription: itm?.materialDescription,
          materialUnit: itm?.materialUnit,
          batchLotNo: itm?.batchLotNo,
          requestQty: itm?.qty
        }))

        dispatch({ type: PicklistAction.Inited, payload: { header: {
          ...orderInfo,
          requestedBy: extraPicklist?.approvedBy, 
          requestedDateTime: extraPicklist?.approvedDateTime,
          approvedBy: extraPicklist.withdrawedBy ? extraPicklist.withdrawedBy : undefined,
          approvedDateTime: extraPicklist.withdrawedDateTime ? extraPicklist.withdrawedDateTime : undefined,
          kiNo: extraPicklist?.kiNo ? extraPicklist.kiNo : undefined,
          commentText: `${extraPicklist?.remark || ''}`,
          extraReturnId: extraPicklist?.id,
          checkedBy: extraPicklist.checkedBy ? extraPicklist.checkedBy : undefined,
          checkedDateTime: extraPicklist.checkedDateTime ? extraPicklist.checkedDateTime : undefined,
          qualityCheckedBy: extraPicklist.qualityCheckedBy ? extraPicklist.qualityCheckedBy : undefined,
          qualityCheckedDateTime: extraPicklist.qualityCheckedDateTime ? extraPicklist.qualityCheckedDateTime : undefined
        }, items: toPicklistItems, comments: []}})

        setOriginalExtra(extraPicklist)
      }
    }

    fetchExtra(extraId!)
  }, [ extraId ])

  const onApproved = async () => {
    const updated = await qaCheckPicklistExtra(originalExtra!, username!)
    const head : DgtPdOrderPicklist = {
      ...header!,
      qualityCheckedBy: updated.qualityCheckedBy,
      qualityCheckedDateTime: updated.qualityCheckedDateTime
    }
    dispatch({ type: PicklistAction.PicklistUpdated, payload: { header: head } })
  }

  const openDialog = () => {
    dispatch({ type: PicklistAction.OpenDialog })
  }

  const closeDialog = () => {
    dispatch({ type: PicklistAction.CloseDialog })
  }

  const { header, showConfirmDialog, itemMovements, items } = state

  useEffect(() => {
    const fetchMovements = async (orderId: string) => {
      const mvs = (await getMovementsById(orderId)).filter(
        mv => mv.movementType !== '262'
        && (!mv.approvedDateTime || mv.extraRefId === extraId)
        && items.map(i => i.materialCode).includes(mv.materialCode)
      ).map(mv => ({
        ...mv,
        materialRequestQty: items.find(item => item.materialCode === mv.materialCode)?.requestQty
      }))
      dispatch({ 
        type: PicklistAction.PicklistItemMovementsUpdated, 
        payload: { 
          itemMovements: mvs
        }})
    }
    fetchMovements(id!)
  }, [ id, items, extraId ])

  useEffect(() => {
    if (itemMovements.length > 0) {
      setExpandedGroupIds(new Set(itemMovements.map(itm => itm.materialCode)))
    }
  }, [ itemMovements ])

  const onRowsChange = async (rows: DgtPdOrderPicklistMovement[], 
    changedInfo: RowsChangeData<DgtPdOrderPicklistMovement>) => {
    const changedRowIdx = changedInfo.indexes[0]
    if (changedRowIdx < 0) return
    
    const changedRow = rows[changedRowIdx]
    const updated = changedRow.qualityCheckedDateTime! > 0 ?
      await qaCheckItemMovement(changedRow, username!) : await qaUncheckItemMovement(changedRow)
    dispatch({ 
      type: PicklistAction.PicklistItemMovementsUpdated,
      payload: {
        itemMovements: rows.map(row => row.sk === updated.sk ? updated : row)
      }
    })
  }

  const disabledComplete = itemMovements.length !== itemMovements.filter(mv => mv.qualityCheckedDateTime).length

  let columns = Array.from(PicklistItemQaCheckMvColumn)
  if (readOnly) columns.splice(-1)

  return <div className="page-container">
    <HeaderDetail title={`${title} Order : ${id} (เบิกเพิ่ม ขอเมื่อ ${formatDateFromUnix(header?.requestedDateTime)})`} header={header}
      isShowRelease={false} isShowRemark={true} />
    <div className='flex items-end justify-between mt-1 mb-2'>
      <small>จ่าย {itemMovements.length} รายการ</small>
      {readOnly ? null : <button className='gap-1 btn-success' onClick={openDialog} disabled={disabledComplete}>
        <AiOutlineCheckCircle />กดเพื่อปล่อย PASS
      </button>}
    </div>
    <DataGrid className='mb-3' 
      style={{ height: "100%", contain: "none" }}
      columns={columns}
      rows={[...itemMovements]}
      rowKeyGetter={(row) => row.id}
      groupBy={['materialCode']}
      rowGrouper={rowGrouper}
      expandedGroupIds={expandedGroupIds}
      onExpandedGroupIdsChange={setExpandedGroupIds}
      defaultColumnOptions={{ resizable: true }}
      onRowsChange={onRowsChange}
    />
    <Link to={`/picklist-qa-check/${id}`} target="_blank"
      className='float-right '>
      <h6 className='text-blue-600 underline '>กดดูใบเบิกหลัก PD Order {id}</h6>
    </Link>
    <Modal show={showConfirmDialog} cancelText='ยกเลิก'
      onHide={closeDialog}
      okText="ใช่"
      okTheme='success'
      okAction={onApproved}
      title={`ยืนยันการตรวจสอบเบิกเพิ่ม Order ${id}`}>
      <div className='flex items-center gap-2'>
        <HiMagnifyingGlass size={50} className='text-green-500 basis-1/6' />
        <div className='space-y-2 basis-5/6'>
          <h6>คุณกำลังยืนยันว่าตรวจสอบ RM ของใบเบิกเพิ่มของ ORDER <span className='font-bold '>{id}</span> ครบถ้วนแล้ว</h6>
          <h6>คุณยืนยันใช่หรือไม่ ?</h6>
        </div>
      </div>
    </Modal>
  </div>
}

export default PicklistQaCheckDetailExtra